import React from 'react';

export interface ServiceGridProps {
  children: React.ReactNode;
  columns?: 1 | 2 | 3 | 4;
  gap?: 'small' | 'medium' | 'large';
  className?: string;
}

export default function ServiceGrid({
  children,
  columns = 2,
  gap = 'large',
  className = ''
}: ServiceGridProps) {
  const getColumnsClass = () => {
    switch (columns) {
      case 1:
        return 'grid-cols-1';
      case 2:
        return 'grid-cols-1 md:grid-cols-2';
      case 3:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
      case 4:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';
      default:
        return 'grid-cols-1 md:grid-cols-2';
    }
  };

  const getGapClass = () => {
    switch (gap) {
      case 'small':
        return 'gap-4';
      case 'medium':
        return 'gap-6';
      case 'large':
        return 'gap-8';
      default:
        return 'gap-8';
    }
  };

  return (
    <div className={`grid ${getColumnsClass()} ${getGapClass()} ${className}`}>
      {children}
    </div>
  );
}
